// extracted by mini-css-extract-plugin
export default {"fs":"_79a4401618 _86615b85fc"};